// Pemilih wilayah di keranjang: kode pos resmi diisi ke checkout lewat URL prefill.
(function () {
  const ADDRESS = 'checkout[shipping_address]';

  // clearStreet: kirim kolom jalan kosong agar Shopify tidak melengkapinya dari alamat tersimpan pelanggan.
  function buildCheckoutUrl(w, recipient, clearStreet) {
    const params = new URLSearchParams([
      [`${ADDRESS}[country]`, 'ID'],
      [`${ADDRESS}[province]`, w.provinceCode],
      [`${ADDRESS}[city]`, w.city],
      [`${ADDRESS}[zip]`, w.zip],
      [`${ADDRESS}[address2]`, `Kel. ${w.village}, Kec. ${w.district}`],
    ]);
    if (recipient && recipient.firstName) params.append(`${ADDRESS}[first_name]`, recipient.firstName);
    if (recipient && recipient.lastName) params.append(`${ADDRESS}[last_name]`, recipient.lastName);
    if (clearStreet) params.append(`${ADDRESS}[address1]`, '');
    return `/checkout?${params}`;
  }

  function toCartAttributes(w) {
    const { provinceCode, provinceName, city, district, village, zip } = w;
    return {
      _wilayah: JSON.stringify({ provinceCode, provinceName, city, district, village, zip }),
      'Wilayah pengiriman': `${village}, ${district}, ${city}, ${provinceName} ${zip}`,
    };
  }

  function parseWilayah(value) {
    try {
      const w = JSON.parse(value);
      return w && typeof w === 'object' && w.zip && w.provinceCode ? w : null;
    } catch {
      return null;
    }
  }

  // Kata yang tidak membedakan wilayah; dibuang dari kueri dan dari kunci shard (build-wilayah.mjs memakai fungsi yang sama).
  const STOP_WORDS = new Set(['kel', 'kelurahan', 'desa', 'ds', 'kec', 'kecamatan', 'kab', 'kabupaten', 'kota', 'adm']);
  const words = (text) => String(text).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter((t) => t && !STOP_WORDS.has(t));

  function searchKey(text) {
    const word = words(text).find((t) => t.length >= 2);
    return word ? word.slice(0, 2) : null;
  }

  const preparedShards = new WeakMap();
  function prepare(shard) {
    if (!preparedShards.has(shard)) {
      preparedShards.set(shard, shard.d.map(([village, district, k, zip]) => {
        const [city, provinceCode, provinceName] = shard.k[k];
        return {
          w: { provinceCode, provinceName, city, district, village, zip },
          village: words(village).join(' '),
          district: words(district).join(' '),
          tokens: [...words(village), ...words(district), ...words(city), ...words(provinceName), zip],
        };
      }));
    }
    return preparedShards.get(shard);
  }

  // Setiap kata kueri harus menjadi awalan kata alamat yang berbeda. Kata terpanjang dicocokkan lebih dulu
  // agar kata pendek tidak merebut kata alamat yang dibutuhkan kata yang lebih spesifik.
  function matchesDistinct(queryWords, tokens) {
    const used = new Set();
    return queryWords.every((q) => {
      const i = tokens.findIndex((token, j) => !used.has(j) && token.startsWith(q));
      if (i < 0) return false;
      used.add(i);
      return true;
    });
  }

  // Urutan: nama kelurahan persis, awalan kelurahan, nama kecamatan persis, awalan kecamatan,
  // lalu kueri yang diawali nama kelurahan atau kecamatan dan disusul nama lain (misalnya kota).
  function searchShard(shard, query, limit = 20) {
    const q = words(query);
    if (!shard || q.length === 0) return [];
    const phrase = q.join(' ');
    const longestFirst = [...q].sort((a, b) => b.length - a.length);
    return prepare(shard)
      .filter((e) => matchesDistinct(longestFirst, e.tokens))
      .map((e) => ({
        w: e.w,
        rank: e.village === phrase ? 0
          : e.village.startsWith(phrase) ? 1
          : e.district === phrase ? 2
          : e.district.startsWith(phrase) ? 3
          : phrase.startsWith(`${e.village} `) ? 4
          : phrase.startsWith(`${e.district} `) ? 5
          : 6,
      }))
      .sort((a, b) => a.rank - b.rank || a.w.village.localeCompare(b.w.village, 'id') || a.w.city.localeCompare(b.w.city, 'id'))
      .slice(0, limit)
      .map((r) => r.w);
  }

  // Selesai saat promise selesai (berhasil atau gagal) atau setelah ms, mana yang lebih dulu.
  function settleWithin(promise, ms) {
    return Promise.race([Promise.resolve(promise).catch(() => {}), new Promise((resolve) => setTimeout(resolve, ms))]);
  }

  function checkoutDecision({ enabled, attr, defaultPrevented }) {
    if (!enabled || defaultPrevented || attr === 'skip') return 'default';
    return parseWilayah(attr) ? 'redirect' : 'block';
  }

  const LOAD_ERROR = 'Daftar wilayah gagal dimuat. Muat ulang halaman, atau pilih "Wilayah saya tidak ada di daftar".';
  const SAVE_ERROR = 'Wilayah gagal disimpan. Coba pilih lagi.';
  const HINT = 'Ketik nama kelurahan atau kecamatan, misalnya Rempoa atau Ciputat Timur.';
  const NO_RESULT = 'Wilayah tidak ditemukan. Periksa ejaan, atau ketik nama kecamatannya.';
  const TOO_MANY = 'Hasil terlalu banyak. Tambahkan nama kecamatan atau kota, misalnya "setu tangerang".';
  const SEARCHING = 'Mencari wilayah...';
  const RESULT_LIMIT = 20;
  const jsonCache = new Map(); // dipakai bersama oleh pemilih di halaman keranjang dan di drawer

  function getJson(url) {
    if (!jsonCache.has(url)) {
      jsonCache.set(url, fetch(url).then((r) => {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }));
      jsonCache.get(url).catch(() => jsonCache.delete(url));
    }
    return jsonCache.get(url);
  }

  function updateCart(body) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => {
      if (!r.ok) throw new Error(r.status);
    });
  }

  // Node (test) tidak punya HTMLElement, jadi kelasnya hanya dibuat di browser.
  const WilayahPickerElement = typeof HTMLElement === 'undefined' ? null : class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('[data-search]');
      this.results = this.querySelector('[data-results]');
      this.hint = this.querySelector('[data-hint]');
      this.wa = this.querySelector('[data-wa]');
      this.searchSeq = 0;
      this.input.addEventListener('input', () => {
        this.resetSearch(Boolean(searchKey(this.input.value)));
        this.timer = setTimeout(() => this.search(this.input.value), 150);
      });
      this.input.addEventListener('keydown', (event) => this.onInputKey(event));
      this.results.addEventListener('keydown', (event) => this.onResultsKey(event));
      this.querySelector('[data-change]').addEventListener('click', () => this.edit(true));
      this.querySelector('[data-skip]').addEventListener('click', () => this.save({ _wilayah: 'skip', 'Wilayah pengiriman': '' }));
      const value = this.dataset.wilayah;
      if (value === 'skip' || parseWilayah(value)) this.showSummary(value);
      else this.edit(false);
    }

    showSummary(value) {
      const w = parseWilayah(value);
      this.querySelector('[data-heading]').textContent = 'Wilayah pengiriman';
      this.querySelector('[data-summary-text]').classList.toggle('wilayah-picker__place', Boolean(w));
      this.wa.hidden = Boolean(w);
      this.querySelector('[data-summary-text]').textContent = w ? `${w.village}, ${w.district}, ${w.city}` : 'Alamat akan diisi manual di checkout. Gunakan kode pos terbaru dari kodepos.posindonesia.co.id agar ongkir muncul.';
      this.querySelector('[data-summary-zip]').textContent = w ? `Kode pos: ${w.zip}` : '';
      this.querySelector('[data-summary]').hidden = false;
      this.querySelector('[data-fields]').hidden = true;
      this.showError('');
    }

    edit(focus) {
      this.dataset.wilayah = ''; // selama memilih ulang, checkout menunggu pilihan baru
      this.querySelector('[data-heading]').textContent = 'Pilih wilayah pengiriman';
      this.querySelector('[data-summary]').hidden = true;
      this.querySelector('[data-fields]').hidden = false;
      this.input.value = '';
      this.resetSearch(false);
      this.renderResults([], HINT);
      this.showError('');
      if (focus) this.input.focus();
    }

    // Hasil lama tidak berlaku lagi begitu ketikan berubah: tidak dapat dipilih dan respons yang masih berjalan diabaikan.
    resetSearch(searching) {
      clearTimeout(this.timer);
      this.searchSeq++;
      this.found = null;
      this.results.setAttribute('aria-busy', String(searching));
      if (searching) this.hint.textContent = SEARCHING;
    }

    async search(query) {
      const seq = ++this.searchSeq;
      const key = searchKey(query);
      if (!key) return this.renderResults([], HINT);
      try {
        const manifest = await getJson(this.dataset.manifestUrl);
        let found = [];
        if (manifest.keys.includes(key)) {
          const shard = await getJson(this.dataset.manifestUrl.replace('wilayah-cari.json', `wilayah-cari-${key}.json`));
          found = searchShard(shard, query, RESULT_LIMIT);
        }
        if (seq !== this.searchSeq) return; // kueri yang lebih baru sudah berjalan
        this.renderResults(found, found.length === 0 ? NO_RESULT : found.length === RESULT_LIMIT ? TOO_MANY : '');
        this.showError('');
      } catch {
        if (seq === this.searchSeq) this.showError(LOAD_ERROR);
      }
    }

    renderResults(found, hint) {
      this.found = found;
      this.wa.hidden = hint !== NO_RESULT;
      this.results.setAttribute('aria-busy', 'false');
      this.hint.textContent = hint;
      this.results.replaceChildren(...found.map((w, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'wilayah-picker__option';
        const place = document.createElement('span');
        place.className = 'body2 wilayah-picker__place';
        place.textContent = `${w.village}, ${w.district}`;
        const detail = document.createElement('span');
        detail.className = 'body3 wilayah-picker__muted';
        detail.textContent = `${w.city}, ${w.provinceName} ${w.zip}`;
        button.append(place, detail);
        button.addEventListener('click', () => this.save(toCartAttributes(w)));
        const item = document.createElement('li');
        item.dataset.index = String(i);
        item.append(button);
        return item;
      }));
    }

    async onInputKey(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        // Enter tidak boleh memakai hasil dari ketikan sebelumnya; cari ulang dulu jika hasilnya belum ada.
        if (!this.found) {
          clearTimeout(this.timer);
          await this.search(this.input.value);
        }
        if (this.found && this.found.length === 1) this.save(toCartAttributes(this.found[0]));
        else this.focusOption(0);
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.focusOption(0);
      }
    }

    onResultsKey(event) {
      const buttons = [...this.results.querySelectorAll('button')];
      const at = buttons.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') this.focusOption(at + 1);
      else if (event.key === 'ArrowUp') (at <= 0 ? this.input : buttons[at - 1]).focus();
      else return;
      event.preventDefault();
    }

    focusOption(index) {
      const buttons = this.results.querySelectorAll('button');
      if (buttons[index]) buttons[index].focus();
    }

    save(attributes) {
      this.resetSearch(false);
      updateCart({ attributes })
        .then(() => {
          document.querySelectorAll('wilayah-picker').forEach((picker) => {
            picker.dataset.wilayah = attributes._wilayah;
            picker.showSummary(attributes._wilayah);
          });
          this.querySelector('[data-change]').focus();
        })
        .catch(() => this.showError(SAVE_ERROR));
    }

    showError(message) {
      this.querySelector('[data-error]').textContent = message;
    }

    // Pelanggan login: jalan dari alamat tersimpan hanya boleh dipakai jika kode posnya sama dengan wilayah pilihan.
    shouldClearStreet(w) {
      if (this.dataset.defaultZip === undefined) return false; // tamu tidak punya alamat tersimpan
      return this.dataset.defaultZip !== w.zip;
    }

    // Nama pelanggan yang login ikut dikirim agar checkout langsung menampilkan form alamat; pembeli yang
    // mengirim ke orang lain menggantinya di form itu.
    recipient() {
      const { firstName = '', lastName = '' } = this.dataset;
      return firstName || lastName ? { firstName, lastName } : null;
    }
  };

  if (WilayahPickerElement && !customElements.get('wilayah-picker')) {
    customElements.define('wilayah-picker', WilayahPickerElement);
  }

  const BLOCK_MESSAGE = 'Pilih kelurahan Anda dulu agar ongkir muncul di checkout.';

  // Fase bubble: pencegah lain (mis. app) yang sudah memanggil preventDefault tetap dihormati.
  if (typeof document !== 'undefined') {
    document.addEventListener('submit', (event) => {
      const button = event.submitter;
      if (!button || button.name !== 'checkout') return;
      const container = button.closest('cart-drawer, #main-cart-footer');
      const picker = container ? container.querySelector('wilayah-picker') : null;
      const decision = checkoutDecision({ enabled: picker !== null, attr: picker && picker.dataset.wilayah, defaultPrevented: event.defaultPrevented });
      if (decision === 'default') return;
      event.preventDefault();

      if (decision === 'block') {
        if (picker.querySelector('[data-fields]').hidden) picker.edit(false);
        picker.showError(BLOCK_MESSAGE);
        picker.input.focus();
        return;
      }

      const w = parseWilayah(picker.dataset.wilayah);
      const note = container.querySelector('textarea[name="note"]');
      const body = { attributes: toCartAttributes(w) };
      if (note) body.note = note.value;
      button.disabled = true;
      button.setAttribute('data-wilayah-busy', '');
      // Request yang gagal atau menggantung tidak boleh menahan pembeli; checkout tetap dibuka.
      const recipient = picker.recipient();
      const clearStreet = picker.shouldClearStreet(w);
      settleWithin(updateCart(body), 4000).then(() => location.assign(buildCheckoutUrl(w, recipient, clearStreet)));
    });

    // Kembali dari checkout lewat bfcache: tombol yang tadi dinonaktifkan harus aktif lagi.
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      document.querySelectorAll('[data-wilayah-busy]').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('data-wilayah-busy');
      });
    });
  }

  const api = { buildCheckoutUrl, toCartAttributes, parseWilayah, checkoutDecision, settleWithin, searchKey, searchShard };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.WilayahPicker = api;
})();
